/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["su-Latn",[["AM","PM"]],u,[["M","S","S","R","K","J","S"],["Mng","Sen","Sal","Reb","Kem","Jum","Sap"],["Minggu","Senén","Salasa","Rebo","Kemis","Jumaah","Saptu"],["Mng","Sen","Sal","Reb","Kem","Jum","Sap"]],u,[["J","P","M","A","M","J","J","A","S","O","N","D"],["Jan","Péb","Mar","Apr","Méi","Jun","Jul","Ags","Sép","Okt","Nop","Dés"],["Januari","Pébruari","Maret","April","Méi","Juni","Juli","Agustus","Séptémber","Oktober","Nopémber","Désémber"]],u,[["SM","M"]],0,[6,0],["d/M/yy","d MMM y","d MMMM y","EEEE, d MMMM y"],["H.mm","H.mm.ss","H.mm.ss z","H.mm.ss zzzz"],["{1}, {0}",u,"{1} 'jam' {0}",u],[",",".",";","%","+","-","E","×","‰","∞","NaN","."],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"IDR","Rp","Rupee Indonésia",{"IDR":["Rp"]},"ltr", plural];
